import React, {useContext, useEffect, useState} from "react";
import "../../../styles/pages/Onboarding/TenantSettings/TenantSettings.scss";
import InputField from "../../../components/Fields/InputField";
import UserData from "../../../store/User/UserData";
import {getTenant, updateTenantData} from "../../../api/ApiClient";
import {captureSentryError} from "../../../util/sentry";
import LoaderButton from "../../../components/Button/LoaderButton";
import {Loader} from "../../../components/Loader/Loader";
import Tooltip from "../../../components/Tooltip/Tooltip";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import {formConfig, tooltipConfig} from "./config/config";
import {validateEmail} from "./config/validation";

const TenantSettings = () => {
  const [userData] = useContext(UserData);
  const tenant = userData?.tenantConfig?.friendly_name
  const [loading, setLoading] = useState(false)
  const [submitLoading, setSubmitLoading] = useState(false)
  const [formData, setFormData] = useState(formConfig(tenant));
  const [error, setError] = useState('')

  const handleInputChange = (value, i) => {
    let updatedForm = [...formData];
    updatedForm[i] = {...updatedForm[i], value};
    setFormData(updatedForm);
  };

  const validateEmailFields = (formData) => {
    let isValid = true;
    formData.forEach(item => {
      if (!item.validateEmail) return;
      if (item.value.trim() === "") {
        delete item.error;
        return;
      }
      const emails = item.value.split(",");
      if (emails.length > 3) {
        item.error = "Max email length is 3.";
        isValid = false;
      } else if (emails.some(email => !validateEmail(email))) {
        item.error = "One or more email fields are invalid.";
        isValid = false;
      } else {
        delete item.error;
      }
    });
    setFormData([...formData])
    return isValid;
  };

  const handleUpdate = async () => {
    if (validateEmailFields(formData)) {
      try {
        setSubmitLoading(true)
        setError('')
        const updatedFields = formData.reduce((acc, item) => {
          acc[item.map] = item.value || "";
          return acc;
        }, {});
        Object.keys(updatedFields).length &&
        (await updateTenantData(userData?.tenant, updatedFields, "PATCH"));
      } catch (e) {
        setError(e?.message)
        captureSentryError(e, userData, "updateTenantData API in wg tenant settings page")
      } finally {
        setSubmitLoading(false)
      }
    }
  };

  useEffect(() => {
    setLoading(true)
    const getTenantData = async () => {
      try {
        const results = await getTenant(userData?.tenant);
        if (results) {
          setFormData(formData.map((item) => ({
            ...item,
            value: results[item.map] && Object.keys(results[item.map]).length ? results[item.map] : ""
          })));
        }
      } catch (e) {
        captureSentryError(e, userData, "getTenantData API in wg tenant settings page")
      } finally {
        setLoading(false)
      }
    };

    userData?.tenant && getTenantData()
    // eslint-disable-next-line
  }, [userData?.tenant])

  return <div className={"tenant-settings-container"}>
    {loading ? <Loader className={"tenant-settings-loader"}/> :
      <>
        <p className={"onboarding-title"}>TENANT SETTINGS</p>
        <div className={"tenant-settings-form"}>
          {formData.map((item, i) =>
            <div className={"form-row flex"} key={item.label}>
              <p className={"form-label"}>{item.label}
                {tooltipConfig[item.label] &&
                <Tooltip content={tooltipConfig[item.label]} direction="right" disableTimeout type={"tenant-settings"}>
                  <InfoOutlinedIcon className="info-icon"/>
                </Tooltip>}
              </p>
              {item.disabled ? <p className={"form-value"}>{item.value}</p> :
                <InputField
                  index={i}
                  className={"input-field"}
                  value={item.value}
                  type={"text"}
                  onChange={handleInputChange}
                />}
              {item?.error && <p className={"error-message"}>{item.error}</p>}
            </div>
          )}
          {error && <p className={"error-message api"}>{error}</p>}
          <LoaderButton
            loading={submitLoading}
            onClick={() => handleUpdate(formData)}
            text={"SAVE"}
            className={"tenant-settings"}
          />
        </div>
      </>}
  </div>;
};

export default TenantSettings;
